import { collection, doc, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import moment from 'moment';
import { useEffect, useRef, useState, useMemo } from 'react';
import { BiChevronDown, BiTransfer } from 'react-icons/bi';
import { FaCheck } from "react-icons/fa6";
import { IoAlertOutline } from 'react-icons/io5';
import { MdNotificationsActive } from 'react-icons/md';
import {
  Avatar,
  HistoricClient,
  LastMessage,
  Menu,
  Modal,
  NoteClient,
  ProfileClient,
  TransferClient,
  VideoCallStatus
} from '../../../../../../../../components';
import { useChat } from '../../../../../../../../contexts/chat';
import { useOutsideAlerter } from '../../../../../../../../hooks';
import { db } from '../../../../../../../../service/serviceChat/chatService';
import { maskDate, NotificationChat, verificationUserExternal } from '../../../../../../../../utils';
import { Container, Content, Date, IconDown, IconNotification, IsSelected, Line, Name, Tag } from './styled';

export function Card(props) {

  const refMenu = useRef();

  const {
    data,
    active,
    loadChats,
    onSelectedCustomer,
    selectedCustomer
  } = props;
  const {
    handOpenView,
    idChat
  } = useChat();

  const [openHistoric, setOpenHistoric] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const [notification, setNotification] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  useOutsideAlerter(refMenu, handleCloseMenu);

  useEffect(() => {
    if (selectedCustomer?.customerServicersID?.includes(data.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedCustomer, data.id]);


  useEffect(() => {
    if (!data.client_phone) return
    var startNotification = false;
    const q = query(
      collection(doc(db(), "chats_new", data.client_phone), "messages"),
      orderBy("date", "desc"),
      limit(1)
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (snapshot.size <= 0) return;
        setNotification({
          docs: snapshot.docs,
          startNotification
        });
        startNotification = true;
      },
      (error) => {
        return unsubscribe();
      }
    );
    return () => {
      unsubscribe();
    }
  }, [data.id]);
  useEffect(() => {
    if (!notification) return;
    const message = notification.docs[0].data();
    setLastMessage(message);
    if (
      (notification.startNotification) &&
      (verificationUserExternal(message)) &&
      (data.client_phone !== idChat)
    ) {
      const notification = new NotificationChat(
        message?.author,
        message?.type === 'text' ? message?.body : 'Nova mensagem',
        data.client_phone
      );
      notification.show();
    }
  }, [notification]);


  const titleTransfer = () => {
    return (
      <div style={{ maxWidth: "25rem" }}>
        Transferir
        <span style={{ fontWeight: "bolder", padding: '0 0.5rem 0 0.5rem' }}>
          {data.client_name}
        </span>
        para :
      </div>
    );
  }

  function handleOpenMenu(e) {
    setAnchorEl(e?.currentTarget)
  };

  function handleCloseMenu() {
    setAnchorEl(null);
  };

  function handleOpenNote() {
    setNoteOpen(true);
  }
  function handleCloseNote() {
    setNoteOpen(false);
  }

  function handleOpenTransfer() {
    handleCloseMenu();
    setTransferOpen(true);
  }
  function handleCloseTransfer() {
    setTransferOpen(false);
  }

  function handleOpenProfile() {
    handleCloseMenu();
    setProfileOpen(true);
  }

  function handleCloseProfile() {
    setProfileOpen(false);
  }

  function handleOpenHistoric() {
    handleCloseMenu();
    setOpenHistoric(true)
  };

  function handOpenChat() {
    if (!selectedCustomer?.isOpen) {
      let aux = data;
      aux.typeWindow = 3;
      handOpenView(aux);
    }
  }
  const isNote = (note) => {
    if (note === undefined
      || !note
      || note === null
      || note === " "
      || note === "undefined"
      || note === "null"
    ) {
      return false
    } else {
      return true
    }
  }

  const handSelectedCustomer = () => {
    if (selectedCustomer?.isOpen) {
      onSelectedCustomer(data.id);
    }
  };

  return (
    <>
      <Container
        active={active}
        isSelected={isSelected}
        onClick={() => handSelectedCustomer()}
        enabledSelection={selectedCustomer?.isOpen}
      >
        <span className='avatar___'>
          {(isSelected)
            ? <IsSelected>
              <FaCheck fontSize={'2rem'} />
            </IsSelected>
            : <Avatar name={data.client_name} />
          }
        </span>
        <Content>
          <Line onClick={() => handOpenChat()}>
            <Name>
              <span>{data.client_name}</span>
            </Name>
            <Date>
              <span>{maskDate(data.started_at) + ' - ' + moment(data.started_at).format('HH:mm')}</span>
            </Date>
          </Line>
          {data.type !== 'VIDEOCHAMADA'
            ? (<>
              <Line>
                <div className='lastMessage' onClick={() => handOpenChat()}>
                  {lastMessage ? <LastMessage message={lastMessage} /> : <>...</>}
                </div>
                <div className='icon-line'>
                  {isNote(data.note) &&
                    <Tag type='note'>
                      <IoAlertOutline className='iconNoteInline' onClick={() => handleOpenNote()} />
                    </Tag>
                  }
                  {verificationUserExternal(lastMessage) &&
                    <IconNotification onClick={() => handOpenChat()}>
                      <MdNotificationsActive />
                    </IconNotification>
                  }
                  <IconDown>
                    <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
                  </IconDown>
                  <IconDown>
                    <BiTransfer onClick={() => handleOpenTransfer()} style={{ fontSize: '1.3rem' }} />
                  </IconDown>
                </div>
              </Line>
            </>)

            : (<>
              <Line>
                <div className='callStatus' onClick={() => handOpenChat()}>
                  <VideoCallStatus dataCall={data?.link} />
                </div>
                <div className='icon-line' onClick={() => handOpenChat()}>
                  {verificationUserExternal(lastMessage) &&
                    <IconNotification onClick={() => handOpenChat()}>
                      <MdNotificationsActive />
                    </IconNotification>
                  }
                  <IconDown >
                    <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
                  </IconDown>
                  <IconDown>
                    <BiTransfer onClick={() => handleOpenTransfer()} style={{ fontSize: '1.3rem' }} />
                  </IconDown>
                </div>
              </Line>
            </>)
          }
        </Content>


        <Menu anchorEl={anchorEl} ref={refMenu}>
          <li onClick={() => handleOpenProfile()}>
            Ver Perfil
          </li>
          <li onClick={() => handleOpenTransfer()}>
            Transferir Atendimento
          </li>
          <li onClick={() => handleOpenHistoric()}>
            Histórico de Atendimento
          </li>
        </Menu>

      </Container>

      {profileOpen &&
        <ProfileClient client={data} isOpen={profileOpen} close={() => handleCloseProfile()} load={loadChats} />
      }
      <Modal title={titleTransfer()} isOpen={transferOpen} close={() => handleCloseTransfer()}>
        {transferOpen && <TransferClient customer={data} close={() => handleCloseTransfer()} />}
      </Modal>
      <Modal title={'Histórico de Atendimento'} isOpen={openHistoric} close={() => setOpenHistoric(!openHistoric)}>
        {openHistoric && <HistoricClient client={data} />}
      </Modal>
      <Modal title={'Anotação'} isOpen={noteOpen} close={() => handleCloseNote()}>
        {noteOpen && <NoteClient idNote={data.id} />}
      </Modal>

    </>

  );
}